export const IncContract = {
  abi: [
    {
      constant: true,
      inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
      name: 'balanceOf',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
  ],
  address:
    process.env.NEXT_PUBLIC_ENV == 'development'
      ? '0x8a810ea8B121d08342E9e7696f4a9915cBE494B7'
      : '0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d',
}
